// oauth-provider/client/authorizeOAuth.ts
import { OAuth2Login, authorizeOAuth as authorizeOAuthMutation } from "../oauth2Login.js";
var requiredParams = [
  "client_id",
  "code_challenge",
  "code_challenge_method",
  "redirect_uri",
  "response_type",
  "scope",
  "state"
];
var authorizeOAuth = async (username, password) => {
  const query = Object.fromEntries(new URLSearchParams(location.search).entries());
  const missingParams = [];
  for (const key of requiredParams)
    if (!query[key])
      missingParams.push(key);
  if (missingParams.length)
    throw new Error(
      `Not all query params required for oauth authorization are present. Required are [${requiredParams.join(
        ", "
      )}]. Missing are [${missingParams.join(", ")}]`
    );
  query.username = username;
  query.password = password;
  const redirect = await authorizeOAuthMutation(new OAuth2Login(query))();
  location.href = redirect;
};
export {
  authorizeOAuth
};
